/**
 * @file
 * Custom scripts for theme.
 */

var _breakpointLarge = 992;
var _breakpointMedium = 768;

(function ($) {

  // Font License Comment.
  Drupal.behaviors.fontLicenseComment = {
    attach: function (context) {
    	
    	var licenseFontText = "\n\
/**\n\
 * @license\n\
 * MyFonts Webfont Build ID 3451044, 2017-09-13T09:27:28-0400\n\
 * \n\
 * The fonts listed in this notice are subject to the End User License\n\
 * Agreement(s) entered into by the website owner. All other parties are \n\
 * explicitly restricted from using the Licensed Webfonts(s).\n\
 * \n\
 * You may obtain a valid license at the URLs below.\n\
 * \n\
 * Webfont: UniversLTPro-65Bold by Linotype\n\
 * URL: https://www.myfonts.com/fonts/linotype/univers/pro-65-bold/\n\
 * Licensed pageviews: 500,000\n\
 * \n\
 * Webfont: UniversLTPro-45Light by Linotype\n\
 * URL: https://www.myfonts.com/fonts/linotype/univers/pro-45-light/\n\
 * Licensed pageviews: 250,000\n\
 * \n\
 * \n\
 * License: https://www.myfonts.com/viewlicense?type=web&buildid=3451044\n\
 * Webfonts copyright: Part of the digitally encoded machine readable outline data for\n\
 * producing the Typefaces provided is copyrighted &#x00A9; 2007 Linotype GmbH,\n\
 * www.linotype.com. All rights reserved. This software is the property of Linotype\n\
 * GmbH, and may not be reproduced, \n\
 * \n\
 * © 2017 MyFonts Inc\n\
*/\n";
    	
    	  $(document.createComment(licenseFontText)).insertBefore("link[href*='MyFontsWebfontsKit.css']");
    }
  }
  


  Drupal.behaviors.globalVariables = {
		  
  }
})(jQuery);


